import React, { Component } from 'react'
import HomePage from './pages/HomePage';
import TotalProcessed from './pages/TotalProcessed';

import {
  Route,
  Routes,
  Link,
  BrowserRouter
} from 'react-router-dom';
import Landing from './pages/Landing';
import Login from './Login';
import TotalProcess from './pages/TotalProcess';
import TopBillsByPage from './pages/TopBillsByPages';
import TopBillsByPages from './pages/TopBillsByPages';
import TopBillsByCharacters from './pages/TopBillsByCharacters';
import InvoiceStatus from './pages/InvoiceStatus';
import InvoiceVolumeForecast from './pages/InvoiceVolumeForecast';
import NewProcess from './pages/NewProcess';
import OpenBills from './pages/OpenBills';
import ForwardDatedBills from './pages/ForwardDatedBills';
import UnlockedBills from './pages/UnlockedBills';
import InvoiceVolumeForecastAccountNumber from './pages/InvoiceVolumeForecastAccountNumber';
import ManuallyTouchedBills from './pages/ManuallyTouchedBills';
import TransportationProviderSearch from './pages/TransportationProviderSearch';
import SettingsGrid from './pages/CustomerSettings';
import HelpFile from './pages/HelpFile';
import UserDetails from './pages/UserDetails';
import CustomerSettings from './pages/CustomerSettings';
import BusinessReviewReport from './pages/BusinessReviewReport';
import ContractManagementReport from './pages/ContractManagementReport';
import VolumeByCustomer from './pages/VolumeByCustomer';
import ImplementationSetup from './pages/ImplementationSetup';
import ImplementationSetupDetail from './pages/ImplementationReport';
import ImplementationReport from './pages/ImplementationReport';
import AuthenticationVerify from './pages/AuthenticationVerify';
import AuthenticationOtp from './pages/AuthenticationOtp';


function RouterLibrary() {

  return (

    <div className='content'>
      {/* <Routes>
        <Route path='/HomePage'>
          <HomePage />
        </Route>

        <Route path="/TotalProcessed">
          <TotalProcessed />
        </Route>
      </Routes> */}
      {/* <nav>
        <Link to="/HomePage">HomePage</Link>
        <Link to="/TotalProcessed">TotalProcessed</Link>
      </nav> */}
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route exact path="/HomePage" element={<HomePage />} />
        <Route exact path="/TotalProcessed" element={<TotalProcess />} />
        <Route exact path="/TopBillsByPages" element={<TopBillsByPages />} />
        <Route exact path="/TopBillsByCharacters" element={<TopBillsByCharacters />} />
        <Route exact path="/InvoiceVolumeForecast" element={<InvoiceVolumeForecast />} />
        <Route exact path="/InvoiceVolumeForecastAccountNumber" element={<InvoiceVolumeForecastAccountNumber />} />
        <Route exact path="/InvoiceStatus" element={<InvoiceStatus />} />
        <Route exact path="/OpenBills" element={<OpenBills />} />
        <Route exact path="/ForwardDatedBills" element={<ForwardDatedBills />} />
        <Route exact path="/UnlockedBills" element={<UnlockedBills />} />
        <Route exact path="/ManuallyTouchedBills" element={<ManuallyTouchedBills />} />
        <Route exact path="/TransportationProviderSearch" element={<TransportationProviderSearch />} />
        <Route exact path="/CustomerSettings" element={<CustomerSettings />} />
        <Route exact path="/UserDetails" element={<UserDetails />} />
        <Route exact path='/BusinessReviewReport' element={<BusinessReviewReport />} />
        <Route exact path='/ContractManagementReport' element={<ContractManagementReport />} />
        <Route exact path='/VolumeByCustomer' element={<VolumeByCustomer />} />
        <Route exact path='/ImplementationSetup' element={<ImplementationSetup/>}/>
        <Route exact path='/ImplementationReport' element={<ImplementationReport/>}/>
        <Route exact path='/AuthenticationVerify' element={<AuthenticationVerify/>}/>
        <Route exact path='/AuthenticationOtp' element={<AuthenticationOtp/>}/>
      </Routes>

    </div>
  )

}
export default RouterLibrary